import React from 'react';
import { event } from '../data/masterclass';
export function TaglineBanner() {
  return <section aria-label="Masterclass tagline" className="bg-ink-soft" data-id="element-80" data-mp="zhuyvp6wwikw">
      <div className="mx-auto flex w-full max-w-6xl flex-col items-center px-6 py-24 text-center lg:py-32" data-id="element-81" data-mp="urelu6706yz2">
        <img src={event.logoUrl} alt="Meet the Eatmons" className="h-28 w-28 object-contain sm:h-32 sm:w-32" data-id="element-82" data-mp="qqkxxctk9k66" />
        <p className="mt-10 font-display text-6xl font-bold uppercase leading-[0.95] text-gold sm:text-7xl lg:text-[7.5rem]" data-id="element-83" data-mp="ls9o3239n9ny">
          Built to
          <span className="block text-white" data-id="element-84" data-mp="bsiqgrjesejn">carry more</span>
        </p>
        <p className="mt-10 max-w-xl text-lg leading-relaxed text-white/60" data-id="element-85" data-mp="bulsyb1r0059">
          {event.dateLabel} at {event.timeLabel} · {event.location}
        </p>
      </div>
    </section>;
}